import React, { useEffect, useState } from "react";
import { api } from "../../config/api";
import { BackEndRoutes } from "../../config/back-end-routes";

interface props {
  idCnpj?:any;
  customerData: any,
  setCustomerData: any,
}


const CustomerPriceTable: React.FC<props> = ({ idCnpj,customerData, setCustomerData }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [priceTable, setPriceTable] = useState([]);
  var i = 0

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { id, value } = event.target;
    setCustomerData((prevForm: any) => ({
      ...prevForm,
      [id]: value,
    }));

  };

  const handlePriceTable = () => {
    setLoading(true);
  
    api.get(BackEndRoutes.routes.TABELA_PRECOS.LIST)
      .then((response: any) => {
        console.info("Sucesso ao buscar tabela de preços:", response.data);
        if (response.data) {
          setPriceTable(response.data);
        }
      })
      .catch((error: any) => {
        console.error("Erro ao buscar tabela de preços:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  

  useEffect(() => {
    handlePriceTable();
  }, []);

  return (
    <div>
      <select
        id="id_tabela"
        className="form-select"
        onChange={handleChange}
        value={customerData.id_tabela}
        disabled={idCnpj ? true : false}
      >
        {priceTable.map((table: any) => (
          <option key={i++} value={table.id_tabela}>
            {table.descricao}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CustomerPriceTable;
